import { Component } from '@angular/core';
import { MessagesService, MessageType } from '@ui-messages';
import { __i18n } from '@localisation';
import { AuthHttp } from '@http';
import { Config } from '@config';
import { UrlEnhancerService } from '@url';
import { DataChangesHandlerService } from '@check';
import { lastValueFrom } from 'rxjs';


@Component({
    selector: 'preregister',
    templateUrl: './preregister.template.html',
    standalone: false
})
export class PreregisterComponent {

    constructor(
        private messages: MessagesService,
        private http: AuthHttp,
        private config: Config,
        private urlEnhancer: UrlEnhancerService,
        private changesService: DataChangesHandlerService
    ){}

    public activationKeys: string;

    public async activate(){
        if(!this.activationKeys || !this.activationKeys.trim()){
            this.messages.addMessage({
                type: MessageType.error,
                text: __i18n('Activation keys not provided.', 'administration.preregister.error.message.keys-not-provided')
            });
        }else{
            let activationKeys = this.activationKeys.split(/[,|\n]/gm);
            activationKeys = activationKeys.filter((current) => !!current.trim());
            activationKeys = activationKeys.map((current) => current.trim());

            try {
                const result = await lastValueFrom(this.http.postJSON(
                    this.urlEnhancer.replaceParams(this.config.services.preregister.preregister),
                    {
                        activationKeys
                    }
                ));
                this.changesService.markAsClean();
                const messageGroupId = Math.random() + '_group';
                if(result.successMessage){
                    this.messages.addMessage({
                        type: MessageType.success,
                        text: result.successMessage,
                        group: messageGroupId
                    });
                }

                if(result.infoMessage){
                    this.messages.addMessage({
                        type: MessageType.info,
                        text: result.infoMessage,
                        group: messageGroupId
                    });
                }

                if(result.errorMessage){
                    this.messages.addMessage({
                        type: MessageType.error,
                        text: result.errorMessage,
                        group: messageGroupId
                    });
                }

            }catch(e){
                this.messages.addMessage({
                    type: MessageType.error,
                    text: e.message
                })
            }
        }
    }
}